import { render, staticRenderFns } from "./ClientPayments.vue?vue&type=template&id=13e979ae&scoped=true&lang=pug&"
import script from "./ClientPayments.vue?vue&type=script&lang=js&"
export * from "./ClientPayments.vue?vue&type=script&lang=js&"
import style0 from "./ClientPayments.vue?vue&type=style&index=0&id=13e979ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e979ae",
  null
  
)

export default component.exports